const ConditionalWrapper = _ref => {
  let {
    children,
    condition,
    wrapper
  } = _ref;
  return condition ? wrapper(children) : children;
};
export default ConditionalWrapper;
//# sourceMappingURL=ConditionalWrapper.js.map